import { useQuery } from 'react-query';

import { GqlRequestOptions } from '@common/api-request';
import { queryOptions } from '@domains/pdp-common';

import { getPdpSizeInputPage } from '../graphql/pdp-size-input-page.2';

const QUERY_KEY = ['getPdpSizeTemplate'];

export const usePdpSizeTemplateQuery = (
  size_category_id?: string | null,
  options?: GqlRequestOptions & { enabled?: boolean },
) => {
  return useQuery(
    [...QUERY_KEY, size_category_id],
    async () => {
      const { data } = await getPdpSizeInputPage({ size_category_id }, options);
      return data;
    },
    {
      ...queryOptions,
      enabled: !!size_category_id && (options?.enabled ?? true),
      staleTime: 1000 * 60 * 60,
      cacheTime: 1000 * 60 * 60 * 24,
    },
  );
};
